import { Timestamp } from '@angular/fire/firestore';

export enum DataRangePreset {
  custom = 'custom',
  last7d = 'last7d',
  last30d = 'last30d',
  thisQuarter = 'thisQuater',
  lastQuarter = 'lastQuater',
  selectedQuarter = 'selectedQuarter',
  last6M = 'last6M',
  thisYear = 'thisYear',
  lastYear = 'lastYear',
}

export const ARCHIVE_PRESETS = [
  { value: DataRangePreset.custom, label: 'Custom range' },
  { value: DataRangePreset.last7d, label: 'Last 7 days' },
  { value: DataRangePreset.last30d, label: 'Last 30 days' },
  { value: DataRangePreset.thisQuarter, label: 'This quarter' },
  { value: DataRangePreset.lastQuarter, label: 'Last quarter' },
  { value: DataRangePreset.selectedQuarter, label: 'Select quarter…' },
  { value: DataRangePreset.last6M, label: 'Last 6 months' },
  { value: DataRangePreset.thisYear, label: 'This year' },
  { value: DataRangePreset.lastYear, label: 'Last year' },
] as const;

export interface QuarterSelection {
  year: number;
  quater: 1 | 2 | 3 | 4;
}

export interface TimestampRange {
  start: Timestamp;
  end: Timestamp;
}
